import type { MouseEvent } from 'react';
import { setSelectedPayGroupId } from 'store/slices/global';

import { selectWithdrawalMethodHandler } from '../../Withdrawal/utils';
import type { AbstractCarouselSelectStrategy } from './AbstractCarouselSelectStrategy';
import type { CarouselSelectStrategyHandlerProps } from './models';

export class CarouselWithdrawalSelectStrategy implements AbstractCarouselSelectStrategy {
  public handle(props: CarouselSelectStrategyHandlerProps, e: MouseEvent): void {
    const { method, platform, dispatch, navigate, flowType } = props;
    selectWithdrawalMethodHandler(
      {
        method,
        platform,
        dispatch,
        navigate,
        flowType,
      },
      e,
    );

    dispatch(setSelectedPayGroupId(method.id));
  }
}
